<app-service-detail #detail [context]="context" [location]="'Actions'">
    <div class="container-fluid px-md-5 px-3">
        <tab-menu class="actions-tab-menu" *ngIf="tabBaseUrl" [items]="tabs" [baseUrl]="tabBaseUrl" [subMenu]="false">
        </tab-menu>
        <div class="actions-content">
            <app-bots *ngIf="isActive('bots')" [useServiceDetailWrapper]="false">
            </app-bots>
            <app-external-links *ngIf="isActive('external-links')">
            </app-external-links>
        </div>
    </div>
</app-service-detail>